"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur gehört jetzt zu SAP.',
    learn: {
      href: '/sap',
      text: 'Mehr erfahren'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'xing',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'KONTAKT',
      href: '/kontakt'
    }, {
      text: 'SUPPORT',
      href: '/support'
    }, {
      text: 'IMPRESSUM',
      href: '/impressum'
    }, {
      text: 'NEWSROOM',
      href: '/newsroom'
    }],
    selector: 'LÄNDERAUSWAHL',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Datenschutz-Impressum',
      href: '/datenschutz-impressum'
    }, {
      text: 'Nutzungsbedingungen',
      href: ''
    }]
  }
};